import store from '@/store/store';
import ApiService from '@/services/api.service';
import { getErrorId } from '@/services/error.service';
import { CONNECT } from '@/app.config';

const DevicesService = {
  /**
   * Obtiene el listado de dispositivos vinculados
   *
   * @returns {Object} - Listado de dispositivos vinculados
   */
  // eslint-disable-next-line consistent-return
  async getDevices(brand) {
    if (store.getters['globalModule/isDemo']) return null;

    // Request
    try {
      const resource = `${brand}/devices`;
      const response = await ApiService.get(resource);

      console.log(brand);
      console.log(response.data);

      let devices = [];
      let extConfigURL = null;

      if (brand === 'honeywell') {
        devices = response.data.map(device => {
          const unit = store.getters['unitsModule/getUnitByThirdPartyDevice'](device.deviceID);
          unit.name = device.name;
          unit.id = device.deviceID;
          unit.mac = device.macID;
          unit.location = device.locationId;
          unit.brand = brand;

          return unit;
        });
      } else if (brand === 'ecobee') {
        devices = response.data.thermostatList.map(device => {
          const unit = store.getters['unitsModule/getUnitByThirdPartyDevice'](device.identifier);
          unit.name = device.name;
          unit.id = device.identifier;
          unit.brand = brand;

          return unit;
        });
      } else if (brand === 'nest') {
        extConfigURL = response.data.ext_config_url;
        devices = response.data.devices.map(device => {
          const unit = store.getters['unitsModule/getUnitByThirdPartyDevice'](device.ext_device_id);
          unit.name = device.ext_name;
          unit.id = device.ext_device_id;
          unit.brand = brand;

          return unit;
        });
      }

      console.log(devices);
      return { brand, devices, extConfigURL };
    } catch (error) {
      const deviceError = getErrorId(error, false);

      if (deviceError === 'notLogged') return { brand, devices: null };
      if (deviceError === 'oauthUnlinked') return { brand, devices: null, relink: true };
      // if (deviceError === 'getOauth2Info') return { brand, devices: null };

      throw new Error(error);
    }
  },

  /**
   * Vincula una cuenta
   *
   * @returns {Object} - Listado de dispositivos vinculados
   */
  async linkAccount(brand) {
    if (store.getters['globalModule/isDemo']) return null;

    // Request
    const resource = `${brand}/code_params`;
    const response = await ApiService.get(resource);

    return response.data;
  },

  /**
   * Desvinvula un dispositivo
   *
   * @returns {Object} - Listado de dispositivos vinculados
   */
  async unlinkDevice(brand, installationID, mac) {
    if (store.getters['globalModule/isDemo']) return null;

    // Request
    const resource = `${brand}/unlink/${mac}`;
    await ApiService.post(resource);

    console.log(resource);

    store.dispatch('unitsModule/updateDevice', {
      installationID,
      deviceMac: mac,
      data: {
        link_manufacturer: '',
        link_deviceID: '',
      },
    });

    return true;
  },

  /**
   * Vincula un dispositivo con un webserver
   *
   * @returns {Object} - Listado de dispositivos vinculados
   */
  async linkDevice(brand, data) {
    if (store.getters['globalModule/isDemo']) return null;

    // Request
    const resource = `${brand}/link/${CONNECT.SCOPE}`;
    await ApiService.post(resource, data);

    console.log(resource);
    console.log(data);

    return true;
  },

  /**
   * Vincula un dispositivo con un webserver
   *
   * @returns {Object} - Listado de dispositivos vinculados
   */
  async unlinkAccount(brand) {
    if (store.getters['globalModule/isDemo']) return null;

    // Request
    const resource = `${brand}/unauthorize`;
    await ApiService.post(resource);

    console.log(resource);

    return true;
  },

  /**
   * Devuelve la información de la última versión disponible para actualizar de un webserver
   *
   * @param {String} deviceId - Mac del webserver
   * @return {Object} - El objeto con la información de la versión para actualizar el webserver
   */
  async getDeviceVersion(deviceId) {
    const requestUrl = `devices/ws/${deviceId}/latestVersion/${CONNECT.SCOPE}`;

    try {
      const response = await ApiService.get(requestUrl);
      // console.log('In getDeviceVersion: ', response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  /**
   * Actualiza un webserver a la versión especifica
   *
   * @param {String} deviceId - Id del webserver a actualizar
   * @param {String} versionId - Id de la version a actualizar
   * @return {Object} - El objeto vacío
   */
  async upgradeDeviceVersion(deviceId) {
    const requestUrl = `devices/ws/${deviceId}/upgradeLatest/${CONNECT.SCOPE}`;

    try {
      const response = await ApiService.patch(requestUrl);
      // console.log('In updateDeviceVersion: ', response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

export default DevicesService;
